<template>
  <router-view />
</template>

<style lang="scss">
// 3rd party plugins css
@import "~perfect-scrollbar/css/perfect-scrollbar.css";
@import "~animate.css";
@import "assets/plugins/keenthemes-icons/font/ki.css";
</style>

<script>
import i18nService from "@/core/services/i18n.service.js";

export default {
  name: "MetronicVue",
  mounted() {
    if (i18nService.isActiveLanguageDirectionRtl()) {
      import("./styles/css/style.vue.rtl.css");
      document.body.style.direction = "rtl";
      document.body.setAttribute("direction", "rtl");
      document.body.setAttribute("dir", "rtl");
    } else {
      import("./styles/css/style.vue.css");
    }
  }
};
</script>
